import React from "react";
import Media from "../component/Media";

function MediaContainer({ mediaData }) {
  return <Media mediaData={mediaData}></Media>;
}
export default MediaContainer;
